import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home'
import Stap1 from '../views/Stap1'
import Stap2 from '../views/Stap2'
import Stap3 from '../views/Stap3'
import Stap4 from '../views/Stap4'
import Stap5 from '../views/Stap5'
import Verzenden from '../views/Verzenden'
import Klaar from '../views/Klaar'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/stap-1',
    name: 'Stap1',
    component: Stap1,
  },
  {
    path: '/stap-2',
    name: 'Stap2',
    component: Stap2,
  },
  {
    path: '/stap-3',
    name: 'Stap3',
    component: Stap3,
  },
  {
    path: '/stap-4',
    name: 'Stap4',
    component: Stap4,
  },
  {
    path: '/stap-5',
    name: 'Stap5',
    component: Stap5,
  },
  {
    path: '/verzenden',
    name: 'Verzenden',
    component: Verzenden,
  },
  {
    path: '/klaar',
    name: 'Klaar',
    component: Klaar,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
